var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",class:((_vm.cookiesOffset ? 'has-cookies-offset' : '') + " " + (_vm.animated ? 'animated' : ''))},[_c('app-header-logo'),_vm._v(" "),_c('app-header-trigger')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5911e940","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/app-header/template.html
// module id = null
// module chunks = 